import React, { useContext, useEffect, useState } from 'react';
import { Breadcrumb, Grid, Header, Menu } from "semantic-ui-react";
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { ClippedContent, Button, STATUS_TYPES, Notification } from "dyl-components";

import FavoriteIcon from 'shared/FavoriteIcon';
import { FAVORITE_TYPE } from 'shared/constants/FAVORITE_TYPE';
import TextCampaignModal from 'shared/modals/TextCampaignModal';
import { useDispatch, useSelector } from 'react-redux';
import campaignContactsActions from 'actions/campaign_contacts';
import { RefreshTextCampaignModal } from 'shared/modals';
import templateCategoryActions from "actions/template_category"
import tcrActions from "actions/tcr"
import campaignActions from 'actions/campaigns'
import { BulkActionsContext } from 'shared/context/BulkActionsProvider';

import dialerActions from 'actions/dialer';
import { PhoneUtil } from 'utils';
import RefreshDialer from '../RefreshDialer';
import { MainSidePanelContext } from 'shared/context/MainSidePanelProvider';
import officeViewActions from 'actions/office_view';
import contactsActions from 'actions/contacts';

const CampaignTabsHeader = ({ id, campaign, userNotInCompanyCampaign }) => {
    const campaignStatus = (campaign.status || '').toLowerCase();
    const isDeleted =  campaignStatus === 'deleted';
    const campaignExpired = campaignStatus === "expired";
    const [openModal, setOpenModal] = React.useState(false);

    const [, setSelectedContacts, , setAreAllContactsInAllPagesSelected] = useContext(BulkActionsContext)

    const { onCloseSidePanel } = useContext(MainSidePanelContext);
    const { dialer, pending_call_contacts, hasDialer, outreachTypes, called_contacts } = useSelector(state => {
        const outreachTypes = (state.campaigns.campaign?.is_company_campaign?.campaign_type || [])?.slice(0).sort();
        return {
            dialer: state.officeView.dialer,
            pending_call_contacts: state.campaigns.campaign.pending_call_contacts,
            called_contacts: state.campaigns.campaign.called_contacts,
            outreachTypes,
            hasDialer: !state.campaigns.campaign?.is_company_campaign?.start_time || outreachTypes.includes("dialer")
        }
    });

    const isStartingDialer = dialer?.status === "loading";
    const isDialerRunning = PhoneUtil.isDialerRunning(dialer);
    const navigate = useNavigate();

    const onClose = () => {
        setOpenModal('');
    }

    const onOpen = (type) => {
        setOpenModal(type);
    }
    const dispatch = useDispatch();

    const isActiveCampaign = campaign?.active_session_id;
    const isCurrentSession = isActiveCampaign && campaign.active_session_id === id;
    const isOnlyDialerCampaign = campaign?.is_company_campaign?.campaign_type === null || !outreachTypes?.includes("text");


    const campaign_id = Number(id);
    const contactID = dialer?.contact_id;
    const [isRefreshDialerModalOpen, setIsRefreshDialerModalOpen] = useState(false);
    useEffect(() => {
        if (contactID && campaign_id === dialer?.campaign_id) {
            navigate(`/contact/${contactID}`);
        }
    }, [contactID, campaign_id, dialer?.campaign_id, navigate]);
    const refresh = () => {
        dispatch(campaignActions.readCampaign(campaign_id))
    }
    const hasContacts = campaign?.total_contact > 0;
    const hasNoPendingCallContacts = pending_call_contacts === undefined;
    const isCompany = Boolean(campaign?.is_company_campaign?.start_time);
    return (
        <>
            <Grid columns='equal'>
                <Grid.Row>
                    <Grid.Column>
                        <Breadcrumb>
                            <Breadcrumb.Section as={Link} to='/campaigns'>
                                Campaigns
                            </Breadcrumb.Section>
                            <Breadcrumb.Divider />
                            <Breadcrumb.Section>
                                {campaign.name}
                            </Breadcrumb.Section>
                        </Breadcrumb>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column>
                        <Header as='h2'>
                            <FavoriteIcon
                                details={{
                                    external_id: Number(id),
                                    favorite_type: FAVORITE_TYPE.CAMPAIGN
                                }}
                                doNotRecordRecent
                            />
                            <Header.Content>{campaign.name}</Header.Content>
                            <Header.Subheader><ClippedContent>{campaign.description}</ClippedContent></Header.Subheader>
                        </Header>
                    </Grid.Column>
                    <Grid.Column>
                        {!isOnlyDialerCampaign &&
                            <>
                                <Button floated='right' primary disabled={campaignExpired || isDeleted || isCurrentSession || !campaign?.text_refresh || !hasContacts || (isCompany && userNotInCompanyCampaign)} onClick={() => {
                                    onOpen('refresh_text');
                                }}>
                                    Refresh Text
                                </Button>
                                <Button floated='right' primary disabled={campaignExpired || isDeleted || !campaign?.textable_contacts || isActiveCampaign} onClick={() => {
                                    onOpen('text');
                                    dispatch(campaignContactsActions.readTextableContacts(id)).then(data => {
                                        setSelectedContacts(data.selected);
                                        setAreAllContactsInAllPagesSelected(true);
                                    })
                                    dispatch(templateCategoryActions.readCategorizedTemplates({ category: 'text' }));
                                    dispatch(tcrActions.getBrand()).then((data) => {
                                        dispatch(tcrActions.getBrandOptOutStatus(data?.brandId))
                                    })
                                }}>
                                    Send Text
                                </Button>
                            </>
                        }
                        {hasDialer && called_contacts && (
                            <Button floated='right' primary onClick={() => { setIsRefreshDialerModalOpen(true) }} type="button" disabled={campaignExpired || isDeleted || isStartingDialer}>
                                Refresh Dialer
                            </Button>
                        )}

                        {hasDialer && (pending_call_contacts || (hasNoPendingCallContacts && !called_contacts)) && (
                            <Button
                                loading={isStartingDialer}
                                floated='right'
                                primary
                                disabled={campaignExpired || isDeleted || isDialerRunning || isStartingDialer || !hasContacts || hasNoPendingCallContacts}
                                onClick={() => {
                                    dispatch(dialerActions.start({}, {
                                        campaign_id
                                    }))
                                        .then(response => {
                                            const contact_id = response.contact_id;
                                            if (contact_id) {
                                                navigate(`/contact/${contact_id}`, { state: { fromDialer: true } });
                                                dispatch(officeViewActions.getActiveCalls())
                                                dispatch(contactsActions.dialerViewLookup(contact_id))
                                                onCloseSidePanel();
                                            } else {
                                                Notification.alert("No contacts available to dial", STATUS_TYPES.ERROR);
                                            }
                                        })
                                        .catch((error) => {
                                            console.error("Error starting dialer", error);
                                            Notification.alert("Failed to start dialer", STATUS_TYPES.ERROR);
                                        });
                                }}
                            >
                                Start Dialer
                            </Button>
                        )}
                        <TextCampaignModal
                            campaign_id={id}
                            onClose={onClose}
                            open={openModal === 'text'}
                            onMessageSend={() => {
                                dispatch(campaignContactsActions.readCampaignContacts(id));
                                dispatch(campaignActions.readCampaign(id));
                                onClose()
                            }}
                        />
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column>
                        <Menu borderless pointing secondary color='primary' stackable>
                            <Menu.Item as={NavLink} name='Dashboard' to={`/campaigns/${id}/dashboard`} />
                            <Menu.Item as={NavLink} name='Contact List' to={`/campaigns/${id}/contacts`} />
                            {
                                isCompany &&
                                <Menu.Item as={NavLink} name='User Reports' to={`/campaigns/${id}/user-reports`} />
                            }
                            {/* May add back in latter <Menu.Item as={NavLink} name='Settings' to={`/campaigns/${id}/settings`} /> */}
                            <Menu.Item as={NavLink} name='History' to={`/campaigns/${id}/history`} />
                            {
                                Object.keys(campaign?.is_company_campaign || {})?.length > 0 &&
                                <Menu.Item as={NavLink} name='Session Summary' to={`/campaigns/${id}/session-summary/${!isOnlyDialerCampaign ? 'text' : 'dialer'}`} />
                            }
                        </Menu>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
            <RefreshDialer open={isRefreshDialerModalOpen} reload={refresh} onClose={() => { setIsRefreshDialerModalOpen(false); }} campaign_id={campaign_id} refresh={refresh} />
            <RefreshTextCampaignModal
                campaign_id={id}
                onClose={onClose}
                open={openModal === 'refresh_text'}
                refresh={() => {
                    dispatch(campaignContactsActions.readCampaignContacts(id));
                    dispatch(campaignActions.readCampaign(id));
                }}
            />
        </>
    );
}

export default CampaignTabsHeader;
